import { createAction, props } from '@ngrx/store';
import { ISiteRedinessMatrix, ISiteRequestProxyMembers, ISiteRequestDetails, ISiteRequestProxyDetails } from 'src/app/feature/site-rediness-matrix/models/request';
import { IGetSiteRequestsResult } from 'src/app/feature/approvals/models/approvals';


export const SaveFacilityDetailsAction = createAction('[SubmitRequestDetails] - Success', props<{ data: ISiteRedinessMatrix }>());

export const GetSiteRequestsApiAction = createAction('[Get Site Requests ]');
export const SucessGetSiteRequestsApiAction = createAction('[Get Site Requests ] - Success', props<{ data: IGetSiteRequestsResult }>());
export const ErrorGetSiteRequestsApiAction = createAction('[Get Site Requests ] - Error', props<Error>());
export const UpdateSiteRequestSelectedIdAction = createAction('[Update Selected Site Request Id ]', props<{ id: number }>());
export const UpdateSiteApprovalSelectedIdAction = createAction('[Update Selected Site Approval Id ]', props<{ id: number }>());

export const UpdateProxyRequestMembersAction = createAction('[Update Site Proxy Request Members ]', props<{ data: ISiteRequestProxyMembers[] }>());
export const DeleteProxyRequestMembersAction = createAction('[Delete Site Proxy Request Members ]', props<{ alias: string, phone: string }>());
export const ClearProxyRequestMembersAction = createAction('[Clear Site Proxy Request Members ]');
export const saveApprovedRequestDetailsAction = createAction('[From Site Template] Save Approved Request Details', props<{ data: ISiteRequestDetails }>());


export const UpdateSiteRequestProxyDetailsAction = createAction('[Update Site Proxy Request Details ]', props<{ data: ISiteRequestProxyDetails }>());
export const ClearSiteRequestProxyDetailsAction = createAction('[Clear Site Proxy Request Details ]');
